import './BackLink.scoped.scss'

const BackLink = ({href}) => (
  <a href={href} className="back-link"></a>
)

export default BackLink
